<template>
    <div>
        <!-- <div v-if="hasSearch" class="text-center">
            <input type="text" v-model="searchTerm" placeholder="Meklēt pēc nosaukuma..."
                   class="my-4 px-4 py-2 ds-input" @input="attemptSearch">
        </div> -->
        <div class="row text-center my-4">
            <div class="col-sm-6 font-weight-bold text-left">Nosaukums</div>
            <div class="col-sm-2 font-weight-bold">Periods</div>
            <div class="col-sm-2 font-weight-bold">1./2. pielikums</div>
            <div class="col-sm-2 font-weight-bold text-right">Darbības</div>
        </div>
        <div class="col-sm-6 mb-3 px-0">
            <h4>Darba apstākļi (1.pielikums)</h4>
        </div>
        <OvpJobConditionListItem v-for="ovpJobCondition in regularOvpJobConditions"
                            :key="ovpJobCondition._id"
                            :ovpJobCondition="ovpJobCondition"/>

    
        <div class="col-sm-6 mt-5 mb-3 px-0">
            <h4>Īpašie darba apstākļi (2.pielikums)</h4>
        </div>
        <OvpJobConditionListItem v-for="ovpJobCondition in speicialOvpJobConditions"
                            :key="ovpJobCondition._id"
                            :ovpJobCondition="ovpJobCondition"/>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import * as ovpStoreTypes from '../../vuex/modules/ovp/ovp.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import OvpJobConditionListItem from './OvpJobConditionListItem';

    export default {
        name: 'ovp-job-condition-list',
        components: {OvpJobConditionListItem},
        props: {
            hasSearch: {
                type: Boolean,
                default: false,
            }
        },
        data: () => ({
            searchTerm: '',
            searchTimeout: null,
        }),
        created() {
            this.getOvpJobConditionList();
        },
        computed: {
            regularOvpJobConditions() {
                return this.ovpJobConditions.filter(({isSpecial}) => !isSpecial);
            },
            speicialOvpJobConditions() {
                return this.ovpJobConditions.filter(({isSpecial}) => isSpecial);
            },
            ...mapGetters('ovp', {
                /** @type {boolean|*} */
                isLoading: ovpStoreTypes.GET_IS_LOADING,
                /** @type {OvpJobCondition[]|*} */
                ovpJobConditions: ovpStoreTypes.GET_OVP_JOB_CONDITIONS,
            }),
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
        },
        methods: {
             ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyOvpJobConditions: companyStoreTypes.SET_CURRENT_COMPANY_OVP_JOB_CONDITIONS,
            }),
            ...mapActions('ovp', {
                /** @type {function|*} */
                getOvpJobConditions: ovpStoreTypes.ACTION_GET_OVP_JOB_CONDITIONS,
            }),
            async getOvpJobConditionList(search = '') {
                const ovpJobConditions = await this.getOvpJobConditions({name: search, companyId: this.$route.params.companyId || this.currentCompany._id});

                if (this.currentCompany._id && ovpJobConditions) {
                    this.setCurrentCompanyOvpJobConditions(ovpJobConditions); 
                }
            },
            /**
             * Search category by name with 500ms delay.
             */
            attemptSearch() {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => this.getOvpJobConditionList(this.searchTerm), 500);
            },
        },
    }
</script>